import { orgReviewCount, orgTripDrop, orgTripReviews } from '../../../api/orgTripAPI';
import errorHandle from '../../../utils/errorHandle';

export const fetchOrgReviews = (setReviews, setLoading, offset, trip = '') => {
    setLoading(true);
    try {
        orgTripReviews(10, offset, trip).then((res) => {
            setReviews(res.data);
            setLoading(false);
        });
    } catch (error) {
        setLoading(false);
        errorHandle(error);
    }
};

export const getTrips = (datesType, group, setTrips, setLoading) => {
    setLoading(true);
    try {
        orgTripDrop(datesType, group).then((res) => {
            setTrips(res.data);
            setLoading(false);
        });
    } catch (error) {
        setLoading(false);
        errorHandle(error);
    }
};

export const reviewsCount = (setTotalCount, trip, setLoading) => {
    setLoading(true);
    try {
        orgReviewCount(trip).then((res) => {
            setLoading(false);
            setTotalCount(res.data.reviewCount);
        });
    } catch (error) {
        setLoading(false);
        errorHandle(error);
    }
};
